import { request } from "../client"
import type { AvailabilityPolicy } from "@kontextwerk/control-web-frame/types/availabilityPolicies"

export type DailyBriefingPreferences = {
  enabled: boolean
  include_pdf: boolean
  include_operations: boolean | null
}

export type UserSettings = {
  daily_briefing?: DailyBriefingPreferences
  availability_policy_id?: string | null
  availability_policy?: AvailabilityPolicy | null
}

export type UserSettingsUpdatePayload = Partial<UserSettings>

export type OrganizationUserSettingsProjection = {
  items: Array<{
    user_id: string
    settings: UserSettings
  }>
}

export const fetchUserSettings = async (userId: string): Promise<UserSettings> =>
  request<UserSettings>(`/users/${userId}/settings`)

export const updateUserSettings = async (
  userId: string,
  payload: UserSettingsUpdatePayload,
): Promise<UserSettings> =>
  request(`/users/${userId}/settings`, { method: "PUT", body: JSON.stringify(payload ?? {}) })

export const fetchOrganizationUserSettingsProjection = async (
  organizationId: string,
): Promise<OrganizationUserSettingsProjection> =>
  request<OrganizationUserSettingsProjection>(
    `/users/settings?organization_id=${encodeURIComponent(organizationId)}&projection=organization_users`,
  )
